﻿// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// Write your JavaScript code.



//-----------------´Från Layout.cshtml

export function initSite() {

    //-----------------Från Home.cshtml

    let sub = window.location.href.indexOf('/bib') > -1 ? '/bib' : '';
    $('#update-button').on('click', function () {
        SetUpdate(1);
    });

    $('#notnow-button').on('click', function () {
        SetUpdate(0);
    });
    $('#hidemessage-button').on('click', function () {
        SetUpdate(2);
    });
    $('#hideinfocontainer-button').on('click', function () {
        SetUpdate(3);
    });

    //-----------------Från DatabaseInfo/Index.cshtml

    $('.goback').on('click', function () {
        GoBack();
    });

    function GoBack() {
        window.history.back()
    }

    //-----------------Slut DatabaseInfo/Index.cshtml

    $(document).foundation();

    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({ 'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start' });
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.async = true; g.src = 'https://tracking.webbanalys.msb.se/js/container_IWweAsmU.js'; s.parentNode.insertBefore(g, s);
    
    const select = document.getElementById("hyllaSelect");

    if (!select) return;

    select.addEventListener("change", function () {

        const rootUrl = this.dataset.rootUrl;
        const selectedValue = this.value;

        if (selectedValue) {
            window.location.href = rootUrl + selectedValue;
        }
    });
        
    function Expand(parent, currentid, clname) {
        let i;
        let siblings = document.getElementsByClassName(clname);
        let hidesiblings = false;
        let NoCollapse = false;
        for (i = 0; i < siblings.length; i++) {
            NoCollapse = false;
            let sibling = siblings[i];
            let siblingParent = sibling.parentNode;
            //let hideParent = clname == "hyllItem" ? sibling.parentNode.parentNode : sibling.parentNode;
            let id = sibling.id;
            id = id.substring(0, 2) == "G_" ? id.substring(2) : id;

            if (id == currentid) {


                if (siblingParent.classList.contains('expanded')) {
                    hidesiblings = true;
                    siblingParent.classList.remove('expanded');
                    siblingParent.classList.add('collapsed');
                }
            }
            //Om vi går nedåt i listan men till en högre nivå så vill vi inte slå ihop underliggande
            if (id.length > currentid.length && currentid.substring(currentid.length - 1) > id.substring(currentid.length - 1, 1)) {
                NoCollapse = true;
            }

            if (!(id.length < currentid.length && currentid.substring(0, id.length) == id) && !NoCollapse) {

                if (siblingParent.classList.contains('expanded') && !sibling.classList.contains('hyllaSelected')) {
                    siblingParent.classList.remove('expanded');
                }

            }

            if (
                (parent == -1 && id.length > 1 && id.substring(0, 1) != currentid) ||
                (id.length > currentid.length && id.substring(0, currentid.length) != currentid ||
                    (id.length > currentid.length && (id.substring(0, currentid.length) == currentid && hidesiblings))
                )) {
                if (!hideParent.classList.contains('hide') && (!NoCollapse || hidesiblings)) {
                    hideParent.classList.add('hide');
                }
            }
            else {
                if (id == currentid && !hidesiblings && siblingParent.classList.contains('collapsed')) {
                    siblingParent.classList.add('expanded');
                    siblingParent.classList.remove('collapsed');
                }
                if (id.length == currentid.length + 2 && id.substring(0, currentid.length) == currentid) {
                    if (hideParent.classList.contains('hide')) {
                        hideParent.classList.remove('hide');
                    }
                }
            }

        }
    }

    //-----------------Slut Layout.cshtml

    function SetUpdate(typ) {

        document.body.classList.add('busy-cursor');
        let url = sub + "/Update/SetUpdateFlag?typ=" + typ;
        switch (typ) {
            case 0:

                document.getElementById("UpdateInfoContainerMain").classList.toggle("hide");
                break;
            case 1:
                {
                    document.getElementById("UpdateInfoContainerMain").classList.toggle("hide");
                    document.getElementById("UpdateInfoContainerResult").classList.toggle("hide");
                    setInterval(function () {
                        url = sub + "/Update/SyncStatus";
                        $.get(url)
                            .done(function (data) {
                                $('#updateOngoingInfo').text(data);
                            });
                    }, 5000);
                }
                break;
            case 2:
                document.getElementById("UpdateAppContainer").classList.toggle("hide");
                break;
            case 3:
                document.getElementById("UpdateInfoContainerMain").classList.toggle("hide");
                document.getElementById("UpdateInfoContainerResult").classList.toggle("hide");
                break;
        }

        $.post(url)
            .done(function (data) {
                if (typ == 1) {
                    $("#UpdateInfoContainerResult").hide();
                }

                if (typ == 1) {
                    location.reload();
                }
                document.body.classList.remove('busy-cursor');
            });
    }

    //-----------------Slut Home.cshtml

    // //-----------------Från DatabaseInfo/Index.cshtml

    // $('.goback').on('click', function () {
    //     GoBack();
    // });

    // function GoBack() {
    //     window.history.back()
    // }

    // //-----------------Slut DatabaseInfo/Index.cshtml

    function menuToggle() {
        document.getElementById("mobileMainMenu").classList.toggle("hide");
    }

    $('#mainMenuToggleButton').on('click', function () {
        menuToggle();
    });
}